"use client";

import { ArrowRight, Building2, Check, MapPin, Truck } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ProductosTuberA() {
  const header = useRevealOnScroll<HTMLDivElement>();
  const services = [{
    icon: Truck,
    title: "Tubería Industrial",
    description: "Soluciones de acero de alta resistencia para aplicaciones estructurales y de conducción. Calidad certificada para proyectos exigentes.",
    features: ["Acero al carbón de alta calidad", "Variedad de cédulas y diámetros", "Cumplimiento con normas ASTM"],
    popular: false,
    to: "/TUBERIAProductosPage"
  }, {
    icon: MapPin,
    title: "Tubería Estructural HSS",
    description: "Perfiles tubulares cuadrados y rectangulares diseñados para soportar grandes cargas con una estética superior en la construcción.",
    features: ["Alta relación resistencia-peso", "Acabados precisos y uniformes", "Ideal para marcos y soportes"],
    popular: true,
    to: "/HSSStructuralProductsPage"
  }, {
    icon: Building2,
    title: "Tubería de Conducción",
    description: "Sistemas especializados para el transporte de fluidos y gases en entornos industriales, garantizando seguridad y durabilidad.",
    features: ["Resistencia a la corrosión", "Pruebas hidrostáticas rigurosas", "Disponibilidad de largos especiales"],
    popular: false,
    to: "/TUBERIAProductosPage"
  }];
  return <section data-section-id="681" id="productos-tubería" className="relative bg-background text-foreground py-24 lg:py-32 overflow-hidden">
      {}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 hidden lg:block opacity-40">
        <svg className="absolute inset-0 w-full h-full" xmlns="http://www.w3.org/2000/svg" fill="none" preserveAspectRatio="none" viewBox="0 0 1200 600">
          <path d="M 100 400 Q 400 200 600 400 T 1100 400" stroke="var(--primary)" strokeWidth="2" strokeDasharray="6 10" opacity="0.35" />
          <path d="M 50 500 Q 350 350 700 500 T 1150 450" stroke="var(--accent)" strokeWidth="2" strokeDasharray="4 12" opacity="0.25" />
        </svg>
      </div>

      <div className="relative container mx-auto px-4 sm:px-6 lg:px-8">
        {}
        <div ref={header.ref} className={`max-w-3xl mx-auto text-center mb-16 lg:mb-20 transition-all duration-700 ${header.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <p className="text-sm font-default font-semibold uppercase tracking-widest text-primary mb-5">
            Nuestras Soluciones
          </p>
          <h2 className="font-default text-4xl sm:text-5xl lg:text-[3.5rem] font-bold leading-[1.05] text-foreground mb-6">
            Tubería de acero para cada{" "}
            <span className="italic text-secondary">proyecto</span>
          </h2>
          <p className="text-lg font-default text-muted-foreground max-w-[600px] mx-auto leading-relaxed">
            Desde estructuras ligeras hasta grandes obras de ingeniería, Kalisch Acero ofrece la gama más completa de tubería industrial y estructural.
          </p>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 items-stretch">
          {services.map((service, i) => {
          const Icon = service.icon;
          return <div key={i} data-index={i} className={`relative group ${service.popular ? "lg:-translate-y-4" : ""}`}>
                {service.popular && <Badge className="absolute -top-3 right-6 z-10 bg-secondary text-secondary-foreground shadow-md uppercase tracking-wider text-[0.7rem] font-bold px-3 py-1 rounded-md">
                    Más Solicitado
                  </Badge>}

                <Card className="h-full min-h-[480px] bg-card border border-border rounded-lg p-10 flex flex-col transition-all duration-300 group-hover:-translate-y-1.5 group-hover:border-primary/60 group-hover:shadow-xl">
                  <CardContent className="p-0 flex flex-col h-full">
                    {}
                    <div className="w-20 h-20 rounded-lg bg-primary-100 flex items-center justify-center mb-8 transition-colors duration-300 group-hover:bg-primary/15 shadow-sm">
                      <Icon className="w-9 h-9 text-primary" strokeWidth={1.75} />
                    </div>

                    {}
                    <h3 className="font-default text-2xl lg:text-[1.75rem] font-semibold text-foreground mb-4 leading-tight">
                      {service.title}
                    </h3>

                    {}
                    <p className="font-default text-muted-foreground leading-relaxed mb-6">
                      {service.description}
                    </p>

                    {}
                    <ul className="space-y-3 mb-8">
                      {service.features.map((feature, idx) => <li key={idx} data-index={idx} className="flex items-start gap-3">
                          <span className="flex-shrink-0 w-5 h-5 rounded-md bg-primary/15 flex items-center justify-center mt-0.5">
                            <Check className="w-3.5 h-3.5 text-primary" strokeWidth={3} />
                          </span>
                          <span className="text-sm font-default text-foreground/85">
                            {feature}
                          </span>
                        </li>)}
                    </ul>

                    {}
                    <div className="mt-auto pt-2">
                      <Link to={service.to} className="inline-flex items-center gap-2 text-primary font-semibold text-sm group/link">
                        <span className="font-default">Ver especificaciones</span>
                        <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover/link:translate-x-1.5" />
                      </Link>
                    </div>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}